import classNames from 'clsx';
import PropTypes from 'prop-types';
import { logFeatureActivity } from '../../actions/logging';
import { addRecentSearch } from '../../actions/search';
import feature from '../../constants/analytics/categoryActionLabel/feature';
import useActions from '../../hooks/useActions';
import css from './recent-searches.module.scss';
import Suggestion from './Suggestion';
import searchCss from './search.module.scss';

export default function SearchSuggestions({ searchResults, onClick }) {
  const { searchTermSuggestions, title } = searchResults;
  const actions = useActions({
    addRecentSearch,
    logFeatureActivity,
  });

  if (!searchTermSuggestions?.length) {
    return null;
  }

  const onSuggestionClick = (searchTerm) => {
    if (searchTerm) {
      onClick(searchTerm);
      actions.addRecentSearch(searchTerm);
      actions.logFeatureActivity(feature.actions.searchSuggestion, feature.labels.click);
    }
  };

  return (
    <div
      data-testid="search-suggestions-container"
      className={classNames(searchCss.containerItems, css.recentSearchesContainer)}
    >
      <div className={css.recentSearchesTitleContainer}>
        <h1 data-testid="search-suggestions-title" className={css.recentSearchesTitle}>
          {title}
        </h1>
      </div>
      {searchTermSuggestions?.map((suggestion) => (
        <Suggestion
          key={`search-suggestion-${suggestion?.index}`}
          suggestion={suggestion}
          onClick={onSuggestionClick}
        />
      ))}
    </div>
  );
}

SearchSuggestions.propTypes = {
  onClick: PropTypes.func.isRequired,
};
